(() => {
  const applySenixSpringSeo = (root) => {
    if (!root) return;
    const title = root.dataset.seoTitle?.trim();
    const description = root.dataset.metaDescription?.trim();
    if (title) document.title = title;
    if (description) {
      let meta = document.head.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
      let openGraph = document.head.querySelector('meta[property="og:description"]');
      if (!openGraph) {
        openGraph = document.createElement('meta');
        openGraph.setAttribute('property', 'og:description');
        document.head.appendChild(openGraph);
      }
      openGraph.setAttribute('content', description);
    }
    if (title) {
      let openGraphTitle = document.head.querySelector('meta[property="og:title"]');
      if (!openGraphTitle) {
        openGraphTitle = document.createElement('meta');
        openGraphTitle.setAttribute('property', 'og:title');
        document.head.appendChild(openGraphTitle);
      }
      openGraphTitle.setAttribute('content', title);
    }
  };
  document.querySelectorAll('[data-senix-spring-seo]').forEach(applySenixSpringSeo);
  document.addEventListener('shopify:section:load', (event) => applySenixSpringSeo(event.target.querySelector('[data-senix-spring-seo]')));
})();
